import React from 'react'
import {DatePicker} from "antd";
import {Field} from "./index";
import moment from "moment";
import {FieldBase} from "./components/FieldBase";

export class FieldDate extends Field {

  constructor(obj={}) {
    super(obj);
  }

  getComponent (form) {
    const dateFormat = ['DD/MM/YYYY'];
    const disabled = this.disabled;

    const DateInput = ({ value, onChange }) => {
      const momentValue = value
        ? (moment.isMoment(value) ? value : moment(value, 'YYYY-MM-DD'))
        : null;

      return (
        <DatePicker
          disabled={disabled}
          format={dateFormat}
          style={{ width: '100%' }}
          value={momentValue}
          onChange={(val) => onChange(val ? val.format('YYYY-MM-DD') : null)}
        />
      );
    };

    return () => (
      <FieldBase condition={this.condition} form={form} size={this.size} label={this.label} name={this.name} value={this.value} help={this.help} rules={this.rules}>
        <DateInput />
      </FieldBase>);
  }

  transformToField = (data) => {
    this.name = data.name;
    this.label = data.label;
    this.type = data.type;
    this.size = data.size ?? this.size;
    this.value = this.transformValueToDate(data.value ?? data.defaultValue);
    this.condition = data.condition ?? true;
    this.disabled = data.disabled ?? false;
    this.help = data.help;
    this.rules = data.rules;

    return this;
  }

  transformValueToDate = (str) => {
    const result = moment(str, 'YYYY-MM-DD')
    return result.isValid() ? str : undefined;
  }

  transformValueToField = (data) => {
    let result = moment(data, "DD/MM/YYYY")
    if(!result.isValid())
      result = moment(data, "YYYY-MM-DD")

    return result;
  };

}


